/**
 * Celebration event types and intensity config
 */
export const CELEBRATION_TYPES = {
  SKILL_COMPLETE: { id: 'skill_complete', intensity: 'small' },
  BADGE_EARNED: { id: 'badge_earned', intensity: 'sparkle' },
  LEVEL_UP: { id: 'level_up', intensity: 'medium' },
  MODULE_COMPLETE: { id: 'module_complete', intensity: 'large', modal: true },
  PROGRAM_COMPLETE: { id: 'program_complete', intensity: 'large', modal: true },
};

/** Intensity priority for deduplication (higher = takes precedence) */
export const INTENSITY_PRIORITY = {
  sparkle: 1,
  small: 2,
  medium: 3,
  large: 4,
};
